import { render, staticRenderFns } from "./catalog-item-price.vue?vue&type=template&id=a9a8b300&"
import script from "./catalog-item-price.vue?vue&type=script&lang=js&"
export * from "./catalog-item-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DiscountChip: require('/var/www/components/DiscountChip/index.vue').default,TippyQuestion: require('/var/www/components/tippy/tippy-question.vue').default})
